import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { type AxiosResponse } from 'axios';
import { QUERY_KEYS } from '@avanta/shared/constants/common';
import { CenterService } from '@avanta/shared/services/centers';
import { type Center } from '@avanta/shared/types/centers';
import { mapToLabelValue } from '../utils/common';

export const useFetchCentersByEnterprise = ({
  enterpriseId,
  isProfileSetup,
}: {
  enterpriseId: string | null;
  isProfileSetup: boolean;
}): UseQueryResult<{ label: string; value: string }[], Error> =>
  useQuery<AxiosResponse<Center[]>, Error, { label: string; value: string }[]>({
    queryKey: [QUERY_KEYS.FETCH_CENTERS_BY_ENTERPRISE, enterpriseId],
    queryFn: () => CenterService.getCentersByEnterprise(enterpriseId ?? ''),
    enabled: Boolean(enterpriseId) && !isProfileSetup,
    select: response => mapToLabelValue(response.data ?? [], 'id', 'centerName'),
  });
